console.log('design');


// use a script tag or an external JS file
// document.addEventListener("DOMContentLoaded", (event) => {
//     gsap.registerPlugin(ScrollTrigger)
//     // gsap code here!

//     const textBox = document.querySelectorAll('.con_text');
//     const bgBox = document.querySelectorAll('.bg_img');
//     const viewBox = document.querySelectorAll('.view_text');

//     if (window.matchMedia('(min-width: 769px)').matches) {
//         textBox.forEach((text) => {
//             gsap.set(text, {
//                 y: 60,
//             })
//             gsap.to(text, {
//                 y: -60,
//                 scrollTrigger: {
//                     trigger: text,
//                     start: 'top bottom',
//                     end: 'bottom top',
//                     scrub: 1
//                 }
//             })
//         })
//     }

//     bgBox.forEach((bg) => {
//         gsap.set(bg, {
//             y: -50
//         })
//         gsap.to(bg, {
//             y: 50,
//             scrollTrigger: {
//                 trigger: bg,
//                 start: 'top bottom',
//                 end: 'bottom top',
//                 scrub: 1
//             }
//         })
//         if (window.matchMedia('(max-width: 769px)').matches){
//             gsap.set(bg, {
//                 y: 50
//             })
//             gsap.to(bg, {
//                 y: -50,
//                 scrollTrigger: {
//                     trigger: bg,
//                     start: 'top bottom',
//                     end: 'bottom top',
//                     scrub: 1
//                 }
//             })
//         }
//     })


//     // viewBox.forEach((view) => {
//     //     gsap.set(view, {
//     //         y: 30
//     //     })
//     //     gsap.to(view, {
//     //         y: -30,
//     //         scrollTrigger: {
//     //             trigger: view,
//     //             start: 'top bottom',
//     //             end: 'bottom top',
//     //             scrub: 1
//     //         }
//     //     })
//     // })
// });